import { render, staticRenderFns } from "./platformManagementList.vue?vue&type=template&id=01b8c1f6"
import script from "./platformManagementList.vue?vue&type=script&lang=js"
export * from "./platformManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports